import React from 'react'

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import { Link, useNavigate } from 'react-router-dom';
import { BsList } from "react-icons/bs";
import { useSelector } from 'react-redux';
import { GoogleLogout } from 'react-google-login';
import { getBaseLink, loggedInUser } from '../../../constants/helpers';
import { googleLogout } from '@react-oauth/google';


const HeadMenu = () => {

  const { data, loading, error, msg, isLoggedIn, isAuthenticated, isAdmin } = useSelector((state) => state.loginData);
  const { data: userProfileData, loading: userProfileLoading } = useSelector((state) => state.userProfileReducer)

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  let navigate = useNavigate();
  
  const clientId = '128373290193-725cpssv8dv3o34c81a2vhqm6dg4a446.apps.googleusercontent.com';
  const logoutUser = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('user_expiresIn');
    localStorage.removeItem('user_data');
    localStorage.removeItem('token');
    console.log('dasdsa');
    googleLogout()
    
    window.location.replace(`${getBaseLink()}/user/login`)
  };
  


  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center', color: '#000', textAlign: 'center' }} className="mainMenu" >
        <Box sx={{
          display: { xs: "none", sm: "flex" }
        }}>
          {
              (userProfileData && userProfileData?.user?.is_vdr) || (loggedInUser && loggedInUser?.data?.user?.is_vdr)  ?
              (
                <>
                
                  <Link to="/">
                    <MenuItem disableRipple >Data Room</MenuItem>
                  </Link>
                </>
              )
            :
            <></>
          }
          {
            isAuthenticated ? 
            <>
            {
              isAdmin === "administrator" ?
              <>
                <Link to="/admin">
                  <MenuItem disableRipple >Admin Dashboard</MenuItem>
                </Link>
              </>
              :
              <>
              <Link to="#0" onClick={()=>logoutUser()}>
                <MenuItem disableRipple >Logout</MenuItem>
              </Link>
              </>

            }
              
            </>
            :
            <>
              <Link to="/user/login">
                <MenuItem disableRipple >Login</MenuItem>
              </Link>
            </>
          }
          

          {/* <a rel="noopener noreferrer" target={'_blank'} href={"https://omkaracapital.in/user/forum"}>
            <MenuItem disableRipple >Blogs</MenuItem>
          </a>
          <Link to="/calendar">
            <MenuItem disableRipple >Result Calendar</MenuItem>
          </Link>
          <Link to="/small-case">
            <MenuItem disableRipple >Smallcase</MenuItem>
          </Link>
          <Link to="/videos">
            <MenuItem disableRipple >Videos</MenuItem>
          </Link> */}
          {/* <a target={'_blank'} href="https://podcast.omkaracapital.in/">
            <MenuItem disableRipple >Podcast</MenuItem>
          </a> */}
          {/* <Link to="/favorite-listing">
            <MenuItem disableRipple >My Favorites</MenuItem>
          </Link> */}
        </Box>


        {/* <a  rel="noopener noreferrer" target={'_blank'} href={"https://omkaracapital.in/user/companyblog/whats-on-my-mind-by-vb"}>
                    <MenuItem disableRipple >What's on My mind</MenuItem>
                </a>
                <a  rel="noopener noreferrer" target={'_blank'} href={"https://omkaracapital.in/open-blog/category-1"}>
                    <MenuItem disableRipple >Result X-Ray</MenuItem>
                </a> */}
        {/* <a  rel="noopener noreferrer" target={'_blank'} href={"https://omkaradata.in/new-test/data2/calendar"}>
                    <MenuItem disableRipple >Result Calender</MenuItem>
                </a> */}

        <Box sx={{
          display: { xs: "block", sm: "none" }
        }}>
          <Tooltip title="Menu">
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              {/* <Avatar sx={{ width: 32, height: 32 }}>M</Avatar> */}
              <BsList color='#000' fontSize={30} />
            </IconButton>
          </Tooltip>
        </Box>


      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {/* <MenuItem>
          <Avatar /> Profile
        </MenuItem>
        <MenuItem>
          <Avatar /> My account
        </MenuItem>
        <Divider /> */}
        <Link className='mobLink' to="/">
          <MenuItem disableRipple >Data Room</MenuItem>
        </Link>
        <Link to="#0" onClick={()=>logoutUser()}>
          <MenuItem disableRipple >Logout</MenuItem>
        </Link>
        {/* <a className='mobLink' rel="noopener noreferrer" target={'_blank'} href={"https://omkaracapital.in/user/companyblog/todays-omkara-thought"}>
          <MenuItem disableRipple >TOT</MenuItem>
        </a>
        <Link className='mobLink' to="/calendar">
          <MenuItem disableRipple >Result Calendar</MenuItem>
        </Link>
        <Link className='mobLink' to="/small-case">
          <MenuItem disableRipple >Smallcase</MenuItem>
        </Link>
        <Link className='mobLink' to="/videos">
          <MenuItem disableRipple >Videos</MenuItem>
        </Link>
        <a target={'_blank'} className='mobLink'  href="https://podcast.omkaracapital.in/">
          <MenuItem disableRipple >Podcast</MenuItem>
        </a>
        <Link className='mobLink' to="/favorite-listing">
          <MenuItem disableRipple >My Favorites</MenuItem>
        </Link> */}
      </Menu>
    </>
  )
}

export default HeadMenu